import { Component, OnInit, Input } from "@angular/core";

@Component({
    selector: "dodo-select",
    templateUrl: "./select.component.html",
    styleUrls: ["./select.component.scss"],
    standalone: false
})
export class SelectComponent implements OnInit {
	@Input() settings;

	constructor() {}

	ngOnInit() {}
}
